/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
export const time = /^([01][0-9]|2[0-3]):[0-5][0-9]$/;
export const timeWithSecondsAliquotFive = /^(2[0-3]|[01]?[0-9]):([0-5]?[0,5]):([0-5]?[0-9])$/;
export const fio = /^([а-яёa-z\u0400-\u04FF\u2019\u02BC\u0027\u00A0]+[ -]{0,1})+$/i;
export const fioOrDash = /^([а-яёa-z\u0400-\u04FF\u2019\u02BC\u0027\u00A0]+[ -]{0,1}|[-])+$/i;
export const text = /[^\s]([\d]*[\s]*[\w]*[а-яА-ЯёЁ\u0400-\u04FF\u2019\u02BC\u0027]*[!?.,]*)+/;
export const email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const belarusianPhone = /^[+375]{4}[ (]{0,2}\d{2}[) ]{0,2}\d{3}[-]{0,1}\d{2}[-]{0,1}\d{2}/;
export const belarusianClearPhone = /^375[0-9]{9}?$/;
// export const startWithBelarusianPrefix = /^[+375]{4}/;
export const startWithBelarusianPrefix = /^\+375/;
export const shortPhone = /^\d{3}[-]{0,1}\d{2}[-]{0,1}\d{2}/;
export const number = /^\d+$/;
export const medicalCardId = /^\d{16}$/;
export const currency = /(?=.*?\d)^\$?(([1-9]\d{0,2}( \d{3})*)|\d+)?(\.\d{1,2})?$/;
export const currencyDisplay = /(\d)(?=(\d\d\d)+(?!\d))/g;
export const newPassword = /^(?=.*[A-Za-z])(?=.*[@$!%*#?&])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
export const username = /^[a-zA-Z0-9]+([_ -]?[a-zA-Z0-9])*[a-zA-Z\d_ -]{4,}$/;
